module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-27.61f6c23f.jpg";